<template>
  <section class="go-beyond-section">
    <div class="container">
      <div class="row">
        <div class="col col-10 offset-1">
          <header class="go-beyond-header">
            <Logo v-animation class="section-logo desktop" data-animation="fade-in-up" />
            <LogoMobile v-animation class="section-logo mobile" data-animation="fade-in-up" />
            <p v-animation class="title-description" data-animation="fade-in-up">
              StatisticsCalculators.com is powered by <a href="https://365datascience.com" target="_blank">365DataScience.com</a>—a leading online platform for AI and data science education and career prep.
            </p>
          </header>
          <p v-animation class="header-description" data-animation="fade-in-up">
            365‘s data experts have created these tools to help learners like you apply key statistical concepts in real-time and validate their results with confidence. If you're here, you're already building skills that drive some of today’s most in-demand careers. Ready to take the next step?
          </p>
        </div>
        <div v-animation class="section-image col col-12" data-animation="pop-out">
          <img src="../../assets/images/home/go_beyond_desktop.webp" alt="How to section image" class="how-to-image">
        </div>
      </div>
      <GoBeyondSection enable-animations />
    </div>
  </section>
</template>

<script>
import GoBeyondSection from '../GoBeyond/GoBeyondSection.vue';
import Logo from '../../assets/svg/calculators-logo-centered.svg?vue-component';
import LogoMobile from '../../assets/svg/calculators-logo-extended.svg?vue-component';

export default {
  components: {
    GoBeyondSection,
    Logo,
    LogoMobile,
  },
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
.go-beyond-section {
  padding: 60px 0;
  background: url("../../assets/images/home/home-bg-gradient-desktop.webp") no-repeat bottom left;

  .go-beyond-header {
    display: flex;
    flex-direction: column;
    align-items: center;

    .section-logo.mobile {
      display: none;
    }

    .title-description {
      margin: 22px 0 0;
      text-align: center;
      color: var(--main-dark-shade-2);
      font-size: 21px;
      line-height: 110%;
    }
  }

  .header-description {
    margin: 30px 0 0;
    color: var(--main-dark-shade-2);
    text-align: center;
    font-size: 18px;
    line-height: 150%;
  }

  .section-image {
    margin-top: 30px;
    margin-bottom: 30px;

    .how-to-image {
      width: 100%;
      height: auto;
      display: block;
    }
  }
}

@include bp($bp-laptop-tablet) {
  .go-beyond-section {
    background-image: url("../../assets/images/home/home-bg-gradient-tablet.webp");

  }
}

@include bp($bp-mobile) {
  .go-beyond-section {
    background-image: none;
    padding: 40px 0;

    .go-beyond-header {
      overflow: hidden;

      .title-description {
        font-size: 18px;
      }
    }

  }
}

@include bp($bp-phone) {
  .go-beyond-section {
    .go-beyond-header .section-logo {
      &.desktop {
        display: none;
      }

      &.mobile {
        display: block;
      }
    }
  }
}
</style>
